const BULK_MIGRATION_ROOT_URL = 'bulk_migration';
export const LOAD_APPROVAL_REQUIREMENTS = `${BULK_MIGRATION_ROOT_URL}/approval_requirements`;
export const ADD_USERS_TO_GROUPS = `${BULK_MIGRATION_ROOT_URL}/approval_requirements/add_user_to_groups`;
